import { graphql } from 'relay-runtime';

export const classById = graphql`
  query ClassByIdQuery($classId: ID!, $skip: Boolean = false, $validCurrentRoadmapsOnly: Boolean = false) {
    class(classId: $classId) @skip(if: $skip) {
      id
      name
      section
      site {
        id
        name
      }
      gradeLevels {
        name
        id
      }
      isActive
      users {
        studentTargetGroups(validCurrentRoadmapsOnly: $validCurrentRoadmapsOnly) {
          id
          isCurrent
          targetGroup {
            id
            name
          }
        }
        id
        firstName
        lastName
        email
        publicUserId
        isActive
        externalSync {
          source
        }
        roles {
          name
        }
        sites {
          id
          name
        }
        classes {
          name
          section
        }
        gradeLevels {
          name
          id
        }
        userClasses {
          isActive
          class {
            id
            name
            section
          }
        }
      }
      createdBy {
        id
        firstName
        lastName
      }
      externalSync {
        source
      }
    }
  }
`;
